<template>
    <div
        class="transfer-banner"
        :style="backgroundImage('pages/for-individuals/money-transfers/cards-transfer.png')"
    >
        <h3 class="h3 mb-16">Онлайн-перевод<br>с&nbsp;карты на&nbsp;карту</h3>
        <p class="transfer-banner__desc mb-32">
            Для совершения перевода ваша карта должна поддерживать технологию защиты 3-D Secure
        </p>
        <UILink
            class="main-banner__btn ui-button"
            href="https://widget3.intervale.ru/?portal_id=P2PCENTRINVESTBANK765FAAFC1730D8"
            label="Перевести"
            blank
            link-color="white"
            rel
        />
    </div>
</template>

<script>
import {defineComponent} from 'vue';
import {UILink} from '@cibsite/ui-components-vue2';

import {useCompressedBackgroundImage} from '@/core/composables/useCompressedBackgroundImage';

export default defineComponent({
    name: 'TransferBanner',
    components: {
        UILink,
    },
    setup() {
        const {backgroundImage} = useCompressedBackgroundImage();

        return {
            backgroundImage,
        };
    },
});
</script>

<style lang="scss">
@import '@/assets/styles/components/home-page/transfer-banner';
</style>
